/**
 * Convert a credit card brand to CVC/CID data, as American Express uses
 * different syntax / naming.
 */
export default function /* @ngInject */ stripeCvc() {
    return function(brand) {
        if (brand === 'American Express') {
            return {
                term: 'CID',
                help: 'Enter the 4 digit CID displayed just above the card number on the right',
                pattern: /^[0-9]{4}$/,
                placeholder: '1234',
                digits: 4,
                isAmex: true
            };
        }

        return {
            term: 'CVC',
            help: 'Enter the 3 digit CVV displayed on the back of your card',
            pattern: /^[0-9]{3}$/,
            placeholder: '123',
            digits: 3,
            isAmex: false
        };
    };
}



// WEBPACK FOOTER //
// ./stripe/filters/stripe-cvc.js